/** Layout constants and colour classes shared by the Insights cycle chart components. */

export const GUTTER_WIDTH = 72;
export const HEADER_HEIGHT = 24;
export const PHASE_STRIP_HEIGHT = 8;
export const LANE_HEIGHT = 28;
export const EMPTY_TEMPERATURE_HEIGHT = 34;
export const PLOT_PAD_Y = 10;

/** Palette for the multi-cycle overlay. Each also gets its own dash so colour isn't the only cue. */
export const OVERLAY_PALETTE = [
  { stroke: "stroke-emerald-600 dark:stroke-emerald-400", fill: "fill-emerald-600 dark:fill-emerald-400", dash: undefined },
  { stroke: "stroke-violet-600 dark:stroke-violet-400", fill: "fill-violet-600 dark:fill-violet-400", dash: "6 3" },
  { stroke: "stroke-sky-600 dark:stroke-sky-400", fill: "fill-sky-600 dark:fill-sky-400", dash: "2 3" },
  { stroke: "stroke-orange-500 dark:stroke-orange-400", fill: "fill-orange-500 dark:fill-orange-400", dash: "8 3 2 3" },
  { stroke: "stroke-rose-500 dark:stroke-rose-400", fill: "fill-rose-500 dark:fill-rose-400", dash: "10 4" },
  { stroke: "stroke-slate-500 dark:stroke-slate-300", fill: "fill-slate-500 dark:fill-slate-300", dash: "3 2 1 2" },
] as const;

export const overlayColor = (index: number) => OVERLAY_PALETTE[index % OVERLAY_PALETTE.length];

/** Same colours as the calendar's monitor chip (observation-day-cell getMonitorBadgeClass). */
export const MONITOR_BADGE_CLASS = {
  low: "bg-slate-700 text-white",
  high: "bg-blue-700 text-white",
  peak: "bg-violet-700 text-white",
} as const;
